// consts
import { PAD_ITEM_TYPE } from '../../../../../config/pad_item';
// class
import PadItemFurniture from 'app/redux/reducers/pad-creator/components-js/pad-item/furniture/PadItemFurniture';

const TEMPLATE_NAME = 'PAD_CREATOR_FURNITURE';

const initialState = () => ({
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: [],
    submit: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      const padItemFurnitures = newData;

      const padItemFurniture = new PadItemFurniture(state);

      // prettier-ignore
      return padItemFurniture
        .prepare(padItemFurnitures, PAD_ITEM_TYPE.FURNITURE)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const newData = action.payload;
      const padItemFurniture = newData.data;

      return new PadItemFurniture(state).add(padItemFurniture).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padItemFurniture = { ...newData.data };

      return new PadItemFurniture(state).edit(padItemFurniture).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padItemFurniture = newData.data;

      return new PadItemFurniture(state).remove(padItemFurniture).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_APPLY_PREDEFIDED_MODEL`: {
      const newData = action.payload;
      const padItemFurniture = newData.data;

      return new PadItemFurniture(state)
        .appyPredefinedModel(padItemFurniture)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
